import { RouteObject } from "react-router";

import { Lazy } from "@shared/components/ui/lazy";
import { useAppName } from "@shared/hooks/useAppName";
import { getAgendaRoutes } from "@shared/features/agenda/routes";
import { getPatientManagementRoutes } from "@shared/features/medicalRecord/routes";
import { getTransmissionRoutes } from "@shared/features/transmission/routes";

const AdminFeedbackDetails = Lazy(
  () => import("@shared/features/feedback/pages/admin-feedback-details"),
  "AdminFeedbackDetails"
);
const OrganizationFeedbackList = Lazy(
  () => import("@shared/features/feedback/pages/organization-feedback-list"),
  "OrganizationFeedbackList"
);
const OrganizationDashboard = Lazy(
  () => import("@shared/features/organization/pages/organization-dashboard"),
  "OrganizationDashboard"
);
const OrganizationExternalPractitioners = Lazy(
  () =>
    import(
      "@shared/features/organization/pages/organization-external-practitioners"
    ),
  "OrganizationExternalPractitioners"
);
const OrganizationRoot = Lazy(
  () => import("@shared/features/organization/pages/OrganizationRoot"),
  "OrganizationRoot"
);
const OrganizationServiceRequests = Lazy(
  () =>
    import("@shared/features/organization/pages/organization-service-requests"),
  "OrganizationServiceRequests"
);
const OrganizationStatistics = Lazy(
  () => import("@shared/features/organization/pages/organization-statistics"),
  "OrganizationStatistics"
);
const OrganizationTeamList = Lazy(
  () => import("@shared/features/organization/pages/OrganizationTeamList"),
  "OrganizationTeamList"
);
const OrganizationTeamProfile = Lazy(
  () => import("@shared/features/organization/pages/organization-team-profile"),
  "OrganizationTeamProfile"
);
const WizardPEC = Lazy(
  () => import("@shared/features/requestCare/pages/WizardPEC"),
  "WizardPEC"
);

export const getOrganizationRoutes = (): RouteObject[] => {
  const { isMobilityCare } = useAppName();

  return [
    {
      path: "organization",
      element: <OrganizationRoot />,
      children: [
        { index: true, element: <OrganizationDashboard /> },
        {
          path: "statistics",
          children: [
            { index: true, element: <OrganizationStatistics /> },
            {
              path: "feedbacks",
              children: [
                { index: true, element: <OrganizationFeedbackList /> },
                { path: ":id", element: <AdminFeedbackDetails /> },
              ],
            },
          ],
        },
        ...getPatientManagementRoutes({ useOrganization: true }),
        {
          path: "requests",
          children: [
            { index: true, element: <OrganizationServiceRequests /> },
            { path: "new", element: <WizardPEC /> },
          ],
        },
        {
          path: "external-practitioners",
          element: <OrganizationExternalPractitioners />,
        },
        { path: "team", element: <OrganizationTeamList /> },
        { path: "team/:id", element: <OrganizationTeamProfile /> },

        ...getAgendaRoutes({ useOrganization: true }),
        ...(isMobilityCare
          ? getTransmissionRoutes({ useOrganization: true })
          : []),
      ],
    },
  ];
};
